import { Component, Input } from '@angular/core';

@Component({
  selector: 'shared-layered-number-description',
  templateUrl: './layered-number-description.component.html',
  styleUrls: ['./layered-number-description.component.scss'],
  host: { class: 'shared-layered-number-description' },
})
export class SharedLayeredNumberDescriptionComponent {
  @Input() number?: number | string;
  @Input() description?: string;
}
